export default __webpack_public_path__ + "static/media/login_right_bg.897e9528.png";